export default "__VITE_ASSET__8dee6fe0__"